import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

export interface Company {
  id: string
  name: string
  legalName: string
  cnpj: string
  logoUrl?: string
}

export const useCompanyStore = defineStore('company', () => {
  const company = ref<Company | null>(null)
  const companies = ref<Company[]>([])
  const isLoading = ref(false)

  const hasCompany = computed(() => !!company.value)
  const companyName = computed(() => company.value?.name || '')
  const companyCnpj = computed(() => company.value?.cnpj || '')

  const setCompany = (companyData: Company) => {
    company.value = companyData
  }

  const setCompanies = (companiesData: Company[]) => {
    companies.value = companiesData
  }

  const selectCompany = (companyId: string) => {
    const selected = companies.value.find(c => c.id === companyId)
    if (selected) {
      company.value = selected
    }
  }

  // TODO: Implementar quando a API estiver pronta
  const fetchCompanies = async () => {
    isLoading.value = true
    try {
      // Mock companies for now
      companies.value = [
        {
          id: '1',
          name: 'Corporativo',
          legalName: 'Empresa Corporativa LTDA',
          cnpj: '00.000.000/0001-00',
        },
      ]
      if (companies.value.length > 0 && !company.value) {
        company.value = companies.value[0]
      }
    } finally {
      isLoading.value = false
    }
  }

  return {
    company,
    companies,
    isLoading,
    hasCompany,
    companyName,
    companyCnpj,
    setCompany,
    setCompanies,
    selectCompany,
    fetchCompanies,
  }
})
